/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const daMessages = {
    /* 01.General */
    'general.copyright': 'Myma.ai © 2019 Alle rettigheder forbeholdes.',

    /* 02.User Login, Logout, Register */
    'user.login-title': 'Login',
    'user.register': 'Registrer',
    'user.forgot-password': 'Glemt adgangskode',
    'user.email': 'E-mail',
    'user.newpassword': 'Ny adgangskode',
    'user.currentpassword': 'Nuværende adgangskode',
    'user.newpasswordagain': 'Ny adgangskode igen',
    'user.password': 'Adgangskode',
    'user.forgot-password-question': 'Glemt adgangskode?',
    'user.fullname': 'Fulde navn',
    'user.firstname': 'Fornavn',
    'user.lastname': 'Efternavn',
    'user.login-button': 'LOGIN',
    'user.register-button': 'REGISTRER',
    'user.reset-password-button': 'NULSTIL',
    'user.buy': 'KØB',
    'user.username': 'Brugernavn',

    /* 03.Menu */
    'menu.app': 'Hjem',
    'menu.online': 'Online',
    'menu.offline': 'Offline',
    'menu.default': 'Standard',
    'menu.analytics': 'Analyse',
    'menu.ecommerce': 'E-handel',
    'menu.content': 'Indhold',
    'menu.pages': 'Sider',
    'menu.data-list': 'Dataliste',
    'menu.thumb-list': 'Miniatureliste',
    'menu.image-list': 'Billedliste',
    'menu.details': 'Detaljer',
    'menu.search': 'Søg',
    'menu.login': 'Login',
    'menu.register': 'Registrer',
    'menu.forgot-password': 'Glemt adgangskode',
    'menu.error': 'Fejl',
    'menu.applications': 'Applikationer',
    'menu.todo': 'To-do Liste',
    'menu.survey': 'Spørgeskema',
    'menu.chat': 'Chat',
    'menu.ui': 'UI',
    'menu.edit': 'Rediger',
    'menu.alerts': 'Advarsler',
    'menu.badges': 'Badges',
    'menu.buttons': 'Knapper',
    'menu.cards': 'Kort',
    'menu.carousel': 'Karrusel',
    'menu.charts': 'Diagrammer',
    'menu.collapse': 'Skjul',
    'menu.dropdowns': 'Dropdowns',
    'menu.editors': 'Editorer',
    'menu.form-layouts': 'Formular-layouts',
    'menu.form-components': 'Formular-komponenter',
    'menu.form-validations': 'Formular-valideringer',
    'menu.icons': 'Ikoner',
    'menu.input-groups': 'Input-grupper',
    'menu.jumbotron': 'Jumbotron',
    'menu.modal': 'Modal',
    'menu.navigation': 'Navigation',
    'menu.popover-tooltip': 'Popover & Tooltip',
    'menu.sortable': 'Sorterbar',
    'menu.tables': 'Tabeller',
    'menu.menu': 'Menu',
    'menu.subhidden': 'Skjult under',
    'menu.hidden': 'Skjult',
    'menu.visible': 'Synlig',
    'menu.maps': 'Kort',
    'menu.landingpage': 'Landing Page',
    'menu.multipage-home': 'Flersidet Hjem',
    'menu.singlepage-home': 'Ensides Hjem',
    'menu.about': 'Om',
    'menu.auth-login': 'Auth Login',
    'menu.auth-register': 'Auth Registrer',
    'menu.blog': 'Blog',
    'menu.blog-detail': 'Blogdetaljer',
    'menu.careers': 'Karriere',
    'menu.confirmation': 'Bekræftelse',
    'menu.contact': 'Kontakt',
    'menu.docs': 'Dokumenter',
    'menu.features': 'Funktioner',
    'menu.prices': 'Priser',
    'menu.videos': 'Videoer',
    'menu.mailing': 'Mailing',
    'menu.invoice': 'Faktura',
    'menu.blank-page': 'Kommer snart...',
    'menu.types': 'Menutyper',
    'menu.levels': 'Menu Niveauer',
    'menu.third-level-1': 'Tredje Niveau 1',
    'menu.third-level-2': 'Tredje Niveau 2',
    'menu.third-level-3': 'Tredje Niveau 3',

    /* 04.Dashboards */
    'dashboards.update': 'Opdater',
    'dashboards.save': 'Gem',
    'dashboards.name': "Navn",
    'dashboards.button': "Knap",
    'dashboards.visits': "Besøg",
    'dashboards.checkAvailability': "Tjek tilgængelighed eller priser",
    'dashboards.details': "Detaljer",
    'dashboards.pending-orders': 'Afventende ordrer',
    'dashboards.completed-orders': 'Fuldførte ordrer',
    'dashboards.refund-requests': 'Refund-anmodninger',
    'dashboards.new-comments': 'Nye kommentarer',
    'dashboards.sales': 'Salg',
    'dashboards.orders': 'Ordrer',
    'dashboards.refunds': 'Refunderinger',
    'dashboards.recent-orders': 'Seneste ordrer',
    'dashboards.product-categories': 'Produktkategorier',
    'dashboards.cakes': 'Kager',
    'dashboards.tickets': 'Billetter',
    'dashboards.calendar': 'Kalender',
    'dashboards.best-sellers': 'Bestsellere',
    'dashboards.per-session': 'Pr. session',
    'dashboards.profile-status': 'Profilstatus',
    'dashboards.payment-status': 'Betalingsstatus',
    'dashboards.work-progress': 'Arbejdsfremskridt',
    'dashboards.tasks-completed': 'Opgaver fuldført',
    'dashboards.payments-done': 'Betalinger udført',
    'dashboards.order-stock': 'Ordre - Lager',
    'dashboards.categories': 'Kategorier',
    'dashboards.quick-post': 'Hurtigt opslag',
    'dashboards.title': 'Titel',
    'dashboards.content': 'Indhold',
    'dashboards.ticket-count': 'Antal billetter',
    'dashboards.commonticketsubmission': 'Almindelige billetindsendelser',
    'dashboards.category': 'Kategori',

    'dashboards.save-and-publish': 'Gem og udgiv',
    'dashboards.top-viewed-posts': 'Mest sete opslag',
    'dashboards.posts': 'Opslag',
    'dashboards.pending-for-publish': 'Afventer udgivelse',
    'dashboards.users': 'Brugere',
    'dashboards.on-approval-process': 'Under godkendelse',
    'dashboards.alerts': 'Advarsler',
    'dashboards.waiting-for-notice': 'Venter på besked',
    'dashboards.files': 'Filer',
    'dashboards.pending-for-print': 'Afventer print',
    'dashboards.logs': 'Logs',
    'dashboards.gogo': 'GOGO',
    'dashboards.magic-is-in-the-details': 'MAGIEN LIGGER I DETALJERNE',
    'dashboards.yes-it-is-indeed': 'Ja, det gør den virkelig!',
    'dashboards.advanced-search': 'Avanceret søgning',
    'dashboards.toppings': 'Toppings',
    'dashboards.type': 'Type',
    'dashboards.keyword': 'Nøgleord',
    'dashboards.search': 'Søg',
    'dashboards.top-rated-items': 'Højest bedømte produkter',
    'dashboards.country': 'Land',
    'dashboards.webVisitors': 'Webbesøgende',
    'dashboards.avatarClicks': 'Avatar klik',
    'dashboards.wordCloud': 'Ordmoln',
    'dashboards.topic': 'Emne',
    'dashboards.roomsAvailability': 'Værelser & tilgængelighed',
    'dashboards.startChat': 'Start en chat',
    'dashboards.restaurantsBars': 'Restauranter & Barer',
    'dashboards.groupBooking': 'Gruppebooking',
    'dashboards.promotions': 'Kampagner',
    'dashboards.weedingevents': 'Bryllup & Begivenheder',
    'dashboards.lostsomething': 'Tabt noget',
    'dashboards.producttext': 'Produkttekst',
    'dashboards.bookingroomnew': 'Booking af nyt værelse',
    'dashboards.email': 'Email',
    'dashboards.phone': 'Telefon',
    'dashboards.zipcode': 'Postnummer',
    'dashboards.marketingconsent': 'Marketingtilladelse',
    'dashboards.additionalinfo': 'Yderligere info',
    'dashboards.viewallcontacts': 'Vis alle kontakter',
    'dashboards.current': 'Nuværende',
    'dashboards.last7days': 'Seneste 7 dage',
    'dashboards.last30days': 'Seneste 30 dage',
    'dashboards.thisweek': 'Denne uge',
    'dashboards.thismonth': 'Denne måned',
    'dashboards.previousmonth': 'Forrige måned',
    'dashboards.yeartodate': 'År til dato',
    'dashboards.lastyear': 'Sidste år',
    'dashboards.all': 'Alle',
    'dashboards.standardOccupancy': 'Standard belægning',
    'dashboards.max-occupancy': 'Maks. belægning',
    'dashboards.numberOfThisType': 'Antal af denne type',
    'dashboards.displayOrder': 'Visningsrækkefølge',
    'dashboards.provider': 'Udbyder',
    'dashboards.edit': 'Rediger',
    'dashboards.delete': 'Slet',
    'dashboards.addImages': 'Tilføj billeder',
    'dashboards.near': 'Nær',
    'dashboards.calling_party': 'Opkaldende bruger',
    'dashboards.called_party': 'Modtagende bruger',
    'dashboards.lastdial': 'Sidste opkald',
    'dashboards.imagelink': 'Billedlink',
    'dashboards.browsegallery': 'Gennemse galleri',
    'dashboards.changelog': 'Ændringslog',
    'dashboards.externalresources': 'Eksterne ressourcer',
    'dashboards.webpage': 'Webside',
    'dashboards.web-pages': 'Websider',
    'dashboards.published': 'Udgivet',
    'dashboards.adddocument': 'Tilføj dokument',
    'dashboards.ready-to-publish': 'Klar til udgivelse',
    'dashboards.draft': 'Kladde',
    'dashboards.order-by': 'Sorter efter',
    'dashboards.add-faq': 'Tilføj FAQ',
    'dashboards.collections': 'Kollektioner',

    'dashboards.items': 'Elementer',
    'dashboards.rooms-availability': 'Værelser & Tilgængelighed',
    'dashboards.events-wedding-venues': 'Begivenheder & Bryllupssteder',
    'dashboards.long-stay-enquiry': 'Forespørgsel om langt ophold',
    'dashboards.reservation-confirmation-request': 'Anmodning om reservationsbekræftelse',
    'dashboards.modify-cancel-booking': 'Ændr eller annuller booking',
    'dashboards.left-something-behind': 'Efterladt noget',
    'dashboards.invoice-copy': 'Faktura/Kvitteringskopi',
    'dashboards.sync': 'Synkroniser',
    'dashboards.add-web-page': 'Tilføj webside',
    'dashboards.sprint-title': 'Mød Sprint, vores banebrydende automatisering, der træner AI-modeller 10× hurtigere.',
    'dashboards.sprint-description': 'Sprint arbejder sammen med dig—for at frigøre kreativitet, øge produktivitet og drastisk reducere tiden til at træne den digitale assistent.',
    'dashboards.sprint-feature': 'Sprint-funktionen synkroniserer viden fra eksterne kilder og er nyttig til både opsætning og løbende dataopdateringer. Når den køres på et aktivt system, ændrer Sprint Knowledge Hub baseret på dine konfigurerede eksterne kilder, hvilket kan påvirke AI-genereret adfærd og svar. Kontakt venligst vores supportteam for hjælp med Sprint-opsætning.',
    'dashboards.change-password': 'Skift adgangskode',
    'dashboards.sign-out': 'Log ud',
    'dashboards.privacy-policy': 'Privatlivspolitik',
    'dashboards.help-center': 'Help Center',
    'dashboards.switch-account': 'Skift konto',
    'dashboards.business-settings': 'Virksomhedsindstillinger',
    'dashboards.notifications-allowed': 'Notifikationer tilladt',
    'dashboards.dark-theme': 'Mørkt tema',
    'dashboards.online': 'Online',
    'dashboards.offline': 'Offline',
    'dashboards.invoice-&-payments': 'Faktura & Betalinger',
    'dashboards.upgrade-plan': 'Opgrader plan',
    'dashboards.add-room': 'Tilføj værelse',
    'dashboards.room-type': 'Værelsestype',
    'dashboards.room-name': 'Værelsesnavn',
    'dashboards.how-many-guests': 'Hvor mange gæster kan bo i dette værelse?',
    'dashboards.number-of-rooms-this-type': 'Antal værelser (af denne type)',
    'dashboards.number-of-bedrooms': 'Antal soveværelser',
    'dashboards.number-of-livingrooms': 'Antal stuer',
    'dashboards.minimum-adults': 'Minimum voksne',
    'dashboards.maximum-adults': 'Maksimum voksne',
    'dashboards.maximum-children': 'Maksimum børn',
    'dashboards.maximum-infants': 'Maksimum spædbørn',
    'dashboards.extra-beds-allowed': 'Ekstra senge tilladt',
    'dashboards.booking-engine-code': 'Booking Engine Code',
    'dashboards.room-size': 'Værelsesstørrelse',
    'dashboards.balcony-area': 'Altanareal',
    'dashboards.unit': 'Enhed',
    'dashboard.whatsapp_message': 'Skriv din besked her...',
    'dashboard.whatsapp_reply_window': 'Du har et 24-timers vindue til at svare på en kundebesked på WhatsApp Business fra det tidspunkt, hvor kunden sidst sendte en besked. Hvis du svarer inden for dette 24-timers kundeservicevindue, kan du sende enhver type besked. Når 24-timers vinduet er lukket, kan du kun sende beskeder ved hjælp af forhåndsgodkendte beskedskabeloner, som genstarter 24-timers vinduet, når kunden svarer.',
    'dashboards.square-meters': 'Kvadratmeter',
    "dashboard.pick_quick_reply": "Vælg et hurtigt svar eller skriv din besked",
    "dashboard.hang_in_there": "Vent venligst, mens vi forsøger at forbinde dig!",
    "dashboard.outbound_msg": "Hvornår den udgående besked skal sendes",
    "dashboard.message_sent": "Din besked er blevet sendt!",
    "dashboard.failed_msg": "Kunne ikke sende beskeden",
    "dashboard.new_chat_message": "Ny chatbesked",
    "dashboard.user_msg": "Der er en brugermeddelelse inden for de sidste 24 timer. Du kan svare med enhver besked. Vil du stadig sende denne skabelonbesked eller svare med en anden besked?",
    "dashboard.us_number": "WhatsApp Business-beskeder sendes ikke til amerikanske numre, fordi Meta satte alle marketingbeskeder til amerikanske numre på pause den 1. april 2025.",
    "dashboard.error_msg": "Udfyld venligst alle pladsholdere korrekt.",

    /* Web Widget */
    'web-widget.title': 'Web Widget-menuer til hjemmesidens chatbot',

    /* Home Page */
    'dashboards.quickstartwithai': 'Hurtig start med AI',
    'dashboards.fastestpathtoautomation': 'Du er på den hurtigste vej til automatisering med AI-værktøjer',
    'dashboards.insightsthatempower': 'Indsigter der styrker',
    'dashboards.trainchatbot': 'Træn Chatbot',
    'dashboards.automatewithforms': 'Automatisér med formularer',
    'dashboards.inroomdigitalcompendium': 'Digitalt kompendium på værelset',
    'dashboards.support': 'Support',
    'dashboards.helpcenter': 'Help Center',
    'dashboards.searchfaqintegrations': 'Søg efter artikler om almindelige FAQ’er, integrationer og mere.',
    'dashboards.asklivechat': 'Stil spørgsmål til vores team i Live Chat',
    'dashboards.inroomqrcode': 'QR-kode på værelset for at se information om ejendommen og området',
    'dashboards.customizewebwidget': 'Tilpas og tilføj Web Widget til din hjemmeside med integreret AI-chatbot',
    'dashboards.createcustomforms': 'Opret tilpassede formularer og få besked, når gæster indsender en formular',
    'dashboards.trainchatbotproperty': 'Træn Chatbot med oplysninger om din ejendom såsom indtjekningstid, aktiviteter m.m.',
    'dashboards.chatbotinsights': 'Se, hvordan din chatbot engagerer gæsterne, og få indsigt i statistik som hjemmesidebesøgende, ofte stillede spørgsmål og meget mere.',
    'dashboards.addaichatbottoyourwebsite': 'Tilføj AI-chatbot til din hjemmeside',

    /* Email Stats */
    'dashboards.thread-summary-title': 'Trådresuméer',
    'dashboards.thread-summary-subtitle': 'E-mailresuméer genereret af AI',
    'dashboards.ai-replies-title': 'AI-svar',
    'dashboards.ai-replies-subtitle': 'Svar genereret af AI',

    'dashboards.total-thread-summary-title': 'Samlede genererede trådresuméer',
    'dashboards.total-ai-replies-title': 'Samlede genererede AI-svar',
    'dashboards.total-draft-copied': 'Kladder kopieret af brugere',

    'dashboards.urgency': 'Hastende niveau',
    'dashboards.sentiment': 'Stemning',

    'dashboards.common-email-reasons': 'Almindelige e-mailårsager',
    'dashboards.topics-in-emails': 'Emner i e-mails',

    'dashboards.email-assistant-usage': 'Brug af AI E-mailassistent',
    'dashboards.usage-by-email-address': 'Forbrug efter e-mailadresse',

    /* 05.Pages */
    'pages.title.dashboards.analytics': 'Analytics',
    'pages.title.ari': 'Tilgængelighed og priser',
    'pages.title.conversations': 'Samtaler',
    'pages.title.bookings': 'Reservationer og bookinger',
    'pages.title.tickets': 'Leads og billetter',
    'pages.title.propinfo': 'Svar',
    'pages.title.discounts': 'Rabatter og kampagner',
    'pages.title.finance': 'Finans',
    'pages.title.integration': 'Integration',
    'pages.title.admin': 'Admin',
    'pages.add-new': 'TILFØJ NY',
    'pages.add-new-modal-title': 'Tilføj nyt element',
    'pages.display-options': 'Visningsmuligheder',
    'pages.orderby': 'Sorter efter : ',
    'pages.product-name': 'Produktnavn',
    'pages.category': 'Kategori',
    'pages.description': 'Beskrivelse',
    'pages.status': 'Status',
    'pages.cancel': 'Annuller',
    'pages.submit': 'Indsend',
    'pages.delete': 'Slet',
    'pages.another-action': 'En anden handling',
    'pages.actions': 'HANDLINGER',
    'pages.header': 'Header',
    'pages.details': 'DETALJER',
    'pages.orders': 'ORDRER',
    'pages.rating': 'Bedømmelse',
    'pages.price': 'Pris',
    'pages.ingredients': 'Ingredienser',
    'pages.is-vegan': 'Er vegansk',
    'pages.order-status': 'Ordrestatus',
    'pages.bake-progress': 'Bagefremgang',
    'pages.popularity': 'Popularitet',
    'pages.comments': 'Kommentarer',
    'pages.error-title': 'Ups... det ser ud til, at der opstod en fejl!',
    'pages.error-code': 'Fejlkode',
    'pages.go-back-home': 'GÅ TILBAGE TIL HJEM',
    'pages.mailing-info':
        'Mailing-skabeloner bruger inline-stilering og tabel-layout for at blive vist korrekt hos forskellige udbydere. For bedre brugervenlighed inkluderer vi det som almindelig HTML via dangerouslySetInnerHTML.',
    'pages.invoice-info':
        'Faktura-skabelonen har en inline-stylet version til brug uden for projektet samt en React-version.',
    'pages.react-version': 'React-version',
    'pages.inline-version': 'Inline stylet HTML-version',

    /* 06.Applications */

    /* 06.01.Chat */
    'chat.messages': 'Beskeder',
    'chat.contacts': 'Kontakter',
    'chat.saysomething': 'Sig noget..',

    /* 06.02.Survey */
    'survey.delete': 'Slet',
    'survey.edit': 'Rediger',
    'survey.add-new': 'TILFØJ NY',
    'survey.add-new-title': 'Tilføj ny undersøgelse',
    'survey.title': 'Titel',
    'survey.category': 'Kategori',
    'survey.label': 'Label',
    'survey.status': 'Status',
    'survey.cancel': 'Annuller',
    'survey.submit': 'Indsend',
    'survey.another-action': 'En anden handling',
    'survey.display-options': 'Visningsmuligheder',
    'survey.orderby': 'Sorter efter : ',
    'survey.all-surveys': 'Alle undersøgelser',
    'survey.completed-surveys': 'Fuldførte undersøgelser',
    'survey.categories': 'Kategorier',
    'survey.active-surveys': 'Aktive undersøgelser',
    'survey.labels': 'Labels',

    /* 06.03.Todo */
    'todo.add-new': 'TILFØJ NY',
    'todo.add-new-title': 'Tilføj ny opgave',
    'todo.title': 'Titel',
    'todo.detail': 'Detalje',
    'todo.category': 'Kategori',
    'todo.label': 'Label',
    'todo.status': 'Status',
    'todo.cancel': 'Annuller',
    'todo.submit': 'Indsend',
    'todo.action': 'Handling',
    'todo.another-action': 'En anden handling',
    'todo.display-options': 'Visningsmuligheder',
    'todo.orderby': 'Sorter efter : ',
    'todo.all-tasks': 'Alle opgaver',
    'todo.pending-tasks': 'Afventende opgaver',
    'todo.completed-tasks': 'Fuldførte opgaver',
    'todo.categories': 'Kategorier',
    'todo.labels': 'Labels',

    /* 07.UI */

    /* 07.01.Alerts */
    'alert.rounded': 'Afrundet alert',
    'alert.react-notifications': 'React-notifikationer',
    'alert.outline': 'Outline',
    'alert.primary': 'Primær',
    'alert.secondary': 'Sekundær',
    'alert.info': 'Info',
    'alert.success': 'Succes',
    'alert.warning': 'Advarsel',
    'alert.error': 'Fejl',
    'alert.filled': 'Fyldt',
    'alert.primary-text': 'Dette er en primær alert—tjek den ud!',
    'alert.secondary-text': 'Dette er en sekundær alert—tjek den ud!',
    'alert.success-text': 'Dette er en succes-alert—tjek den ud!',
    'alert.danger-text': 'Dette er en fare-alert—tjek den ud!',
    'alert.warning-text': 'Dette er en advarsels-alert—tjek den ud!',
    'alert.info-text': 'Dette er en info-alert—tjek den ud!',
    'alert.light-text': 'Dette er en lys alert—tjek den ud!',
    'alert.dark-text': 'Dette er en mørk alert—tjek den ud!',
    'alert.default': 'Standard alert',
    'alert.dismissing': 'Lukkelig alert',
    'alert.dismissing-text':
        'Hold da op! Du bør kigge nærmere på nogle af felterne nedenfor.',
    'alert.dismissing-without-animate-text':
        'Jeg er en alert og kan lukkes uden animation!',

    /* 07.02.Badges */
    'badge.sizes': 'Størrelser',
    'badge.colors': 'Farver',
    'badge.outline': 'Outline',
    'badge.links': 'Links',
    'badge.counter-badges': 'Tæller-badges',
    'badge.bootstrap-default': 'Bootstrap standard',
    'badge.primary': 'Primær',
    'badge.secondary': 'Sekundær',
    'badge.success': 'Succes',
    'badge.danger': 'Fare',
    'badge.warning': 'Advarsel',
    'badge.info': 'Info',
    'badge.light': 'Lys',
    'badge.dark': 'Mørk',

    /* 07.03.Buttons */
    'button.default': 'Bootstrap standard',
    'button.colors': 'Farver',
    'button.rounded': 'Afrundet',
    'button.outline': 'Outline',
    'button.states': 'Tilstande',
    'button.sizes': 'Størrelser',
    'button.button-groups': 'Knapgrupper',
    'button.large-button': 'Stor knap',
    'button.small-button': 'Lille knap',
    'button.extra-small-button': 'Ekstra lille knap',
    'button.block-button': 'Blokknap',
    'button.active': 'Aktiv',
    'button.disabled': 'Deaktiveret',
    'button.basic': 'Basis',
    'button.toolbar': 'Værktøjslinje',
    'button.nesting': 'Indlejring',
    'button.vertical-variation': 'Vertikal variation',
    'button.checkbox-radio-button': 'Checkbox og radioknap',
    'button.checkbox': 'Checkbox',
    'button.radio': 'Radio',
    'button.radio-button': 'Radioknap',
    'button.primary': 'Primær',
    'button.secondary': 'Sekundær',
    'button.success': 'Succes',
    'button.danger': 'Fare',
    'button.warning': 'Advarsel',
    'button.info': 'Info',
    'button.light': 'Lys',
    'button.dark': 'Mørk',
    'button.states-text':
        'Denne knap viser en spinner i 2 sekunder og et fejl-ikon i 3 sekunder, før den vender tilbage til normal tilstand. Disse tilstande kan udløses ved at tilføje eller fjerne klasser.',
    'button.click-here': 'Klik her',
    'button.states-text-alternate':
        'Denne knap viser en spinner i 2 sekunder og et fejl-ikon i 3 sekunder, før den vender tilbage til normal tilstand. Disse tilstande kan udløses ved at tilføje eller fjerne klasser.',
    'button.primary-link': 'Primært link',
    'button.link': 'Link',
    'button.primary-button': 'Primær knap',
    'button.button': 'Knap',
    'button.left': 'Venstre',
    'button.middle': 'Midte',
    'button.right': 'Højre',
    'button.dropdown': 'Dropdown',
    'button.dropdown-link': 'Dropdown-link',

    /* 07.04.Cards */
    'cards.icon-card': 'Ikon-kort',
    'cards.image-card': 'Billedkort',
    'cards.image-overlay-card': 'Billedoverlay-kort',
    'cards.image-card-list': 'Liste med billedkort',
    'cards.tab-card': 'Fankort',
    'cards.user-card': 'Brugerkort',

    /* 07.05.Carousel */
    'carousel.basic': 'Grundlæggende karrusel',
    'carousel.single': 'Enkel karrusel',
    'carousel.without-controls': 'Karrusel uden kontrolknapper',

    /* 07.06.Charts */
    'charts.line': 'Linjediagram',
    'charts.polar': 'Polardiagram',
    'charts.area': 'Arealdiagram',
    'charts.scatter': 'Punktdiagram',
    'charts.bar': 'Søjlediagram',
    'charts.radar': 'Radardiagram',
    'charts.pie': 'Cirkeldiagram',
    'charts.doughnut': 'Donutdiagram',
    'charts.shadow': 'Skygge',
    'charts.no-shadow': 'Ingen skygge',

    /* 07.07.Collapse */
    'collapse.basic': 'Grundlæggende',
    'collapse.toggle': 'Skift',
    'collapse.accordion': 'Harmonika',
    'collapse.controlled': 'Kontrolleret',
    'collapse.uncontrolled': 'Ukontrolleret',

    /* 07.08.Dropdowns */
    'dropdowns.basic': 'Grundlæggende',
    'dropdowns.controlled': 'Kontrolleret',
    'dropdowns.uncontrolled': 'Ukontrolleret',
    'dropdowns.dropdown': 'Dropdown',
    'dropdowns.header': 'Overskrift',
    'dropdowns.action': 'Handling',
    'dropdowns.another-action': 'En anden handling',
    'dropdowns.right': 'Højre',
    'dropdowns.left': 'Venstre',
    'dropdowns.drop-directions': 'Dropdown-retninger',
    'dropdowns.dropright': 'Drop til højre',
    'dropdowns.dropleft': 'Drop til venstre',
    'dropdowns.small-button': 'Lille knap',
    'dropdowns.large-button': 'Stor knap',
    'dropdowns.sizing': 'Størrelse',
    'dropdowns.split-button': 'Split-knap dropdowns',
    'dropdowns.dropup': 'Dropup',

    /* 07.09.Editors */
    'editors.draftjs': 'Draft.js',
    'editors.quill-standart': 'Quill Standard',
    'editors.quill-bubble': 'Quill Boble',

    /* 07.10.Forms */
    'forms.basic': 'Grundlæggende',
    'forms.email': 'E-mail',
    'forms.email-muted': 'Vi deler aldrig din e-mail med andre.',
    'forms.password': 'Adgangskode',
    'forms.submit': 'Send',
    'forms.horizontal': 'Horisontal',
    'forms.radios': 'Radio-knapper',
    'forms.first-radio': 'Første radio',
    'forms.second-radio': 'Anden radio',
    'forms.third-radio-disabled': 'Tredje radio (deaktiveret)',
    'forms.checkbox': 'Afkrydsningsfelt',
    'forms.signin': 'Log ind',
    'forms.top-labels-over-line': 'Topetiketter over linjen',
    'forms.tags': 'Tags',
    'forms.date': 'Dato',
    'forms.state': 'Stat',
    'forms.top-labels-in-input': 'Topetiketter i felt',
    'forms.email-u': 'E-MAIL',
    'forms.password-u': 'ADGANGSKODE',
    'forms.tags-u': 'TAGS',
    'forms.date-u': 'DATO',
    'forms.state-u': 'STAT',
    'forms.grid': 'Formulargitter',
    'forms.address': 'Adresse',
    'forms.address2': 'Adresse 2',
    'forms.city': 'By',
    'forms.city-message': 'Vælg venligst en by!',
    'forms.state-message': 'Vælg venligst en stat!',
    'forms.zip': 'Postnummer',
    'forms.signup': 'Tilmeld',
    'forms.inline': 'Inline',
    'forms.validation-availity': 'Availity Reactstrap Validering',
    'forms.validation-formik': 'Formik Validering',
    'forms.default': 'Standard',
    'forms.firstname': 'Fornavn',
    'forms.firstname-message': 'Indtast venligst dit fornavn!',
    'forms.lastname': 'Efternavn',
    'forms.lastname-message': 'Indtast venligst dit efternavn!',

    /* 07.11.Form Components */
    'form-components.custom-inputs': 'Brugerdefinerede indtastninger',
    'form-components.checkboxes': 'Afkrydsningsfelter',
    'form-components.radios': 'Radio-knapper',
    'form-components.inline': 'Inline',
    'form-components.react-select': 'React Select',
    'form-components.state-single': 'Stat (enkelt)',
    'form-components.state-multiple': 'Stat (flere)',
    'form-components.react-autosuggest': 'React Autosuggest',
    'form-components.date-picker': 'Datovælger',
    'form-components.date': 'Dato',
    'form-components.date-range': 'Datointerval',
    'form-components.date-with-time': 'Dato med tid',
    'form-components.embedded': 'Indlejret',
    'form-components.dropzone': 'Dropzone',
    'form-components.drop-files-here': 'Slip filer her',
    'form-components.tags': 'Tags',
    'form-components.switch': 'Kontakt',
    'form-components.primary': 'Primær',
    'form-components.secondary': 'Sekundær',
    'form-components.primary-inverse': 'Primær invers',
    'form-components.secondary-inverse': 'Sekundær invers',
    'form-components.slider': 'Skyder',
    'form-components.double-slider': 'Dobbelt skyder',
    'form-components.single-slider': 'Enkel skyder',
    'form-components.rating': 'Bedømmelse',
    'form-components.interactive': 'Interaktiv',
    'form-components.readonly': 'Kun læsning',
    'form-components.type-a-cake': 'Skriv en kage',
    'form-components.start': 'Start',
    'form-components.end': 'Slut',
    'form-components.tables': 'Tabeller',

    /* 07.12.Icons */
    'icons.simplelineicons': 'Simple Line Ikoner',
    'icons.iconsmind': 'Iconsmind Ikoner',

    /* 07.13.Input Groups */
    'input-groups.basic': 'Grundlæggende',
    'input-groups.sizing': 'Størrelse',
    'input-groups.small': 'Lille',
    'input-groups.default': 'Standard',
    'input-groups.large': 'Stor',
    'input-groups.checkboxes-and-radios': 'Afkrydsningsfelter og radioer',
    'input-groups.multiple-inputs': 'Flere indtastninger',
    'input-groups.first-and-last-name': 'Fornavn og efternavn',
    'input-groups.multiple-addons': 'Flere tilføjelser',
    'input-groups.button-addons': 'Knaptilføjelser',
    'input-groups.button': 'Knap',
    'input-groups.buttons-with-dropdowns': 'Knapper med dropdowns',
    'input-groups.dropdown': 'Dropdown',
    'input-groups.header': 'Overskrift',
    'input-groups.action': 'Handling',
    'input-groups.another-action': 'En anden handling',
    'input-groups.custom-select': 'Brugerdefineret vælger',
    'input-groups.options': 'Muligheder',
    'input-groups.choose': 'Vælg...',
    'input-groups.custom-file-input': 'Brugerdefineret filupload',

    /* 07.14.Jumbotron */
    'jumbotron.hello-world': 'Hej, verden!',
    'jumbotron.lead':
        'Dette er en simpel hero-enhed, en jumbotron-lignende komponent til at fremhæve vigtigt indhold eller information.',
    'jumbotron.lead-detail':
        'Den bruger hjælpeklasser til typografi og afstand for at strukturere indholdet i den større container.',
    'jumbotron.learn-more': 'Lær mere',

    /* 07.15.Modal */
    'modal.basic': 'Grundlæggende',
    'modal.modal-title': 'Modal titel',
    'modal.launch-demo-modal': 'Åbn demo-modal',
    'modal.scrolling-long-content': 'Rullende langt indhold',
    'modal.backdrop': 'Baggrund',
    'modal.backdrop-value': 'Baggrundsværdi',
    'modal.right-modal': 'Højre modal',
    'modal.launch-right-modal': 'Åbn højre modal',
    'modal.nested-modal': 'Indlejret modal',
    'modal.size': 'Størrelse',
    'modal.launch-large-modal': 'Åbn stor modal',
    'modal.launch-small-modal': 'Åbn lille modal',

    /* 07.16.Navigation */
    'nav.basic': 'Grundlæggende navigation',
    'nav.active': 'Aktiv',
    'nav.disabled': 'Deaktiveret',
    'nav.disabled-link': 'Deaktiveret link',
    'nav.link': 'Link',
    'nav.longer-link': 'Længere link',
    'nav.another-link': 'Et andet link',
    'nav.right': 'Højre',
    'nav.dropdown': 'Dropdown',
    'nav.header': 'Overskrift',
    'nav.action': 'Handling',
    'nav.another-action': 'En anden handling',
    'nav.horizontal-alignment': 'Horisontal justering',
    'nav.vertical-alignment': 'Vertikal justering',
    'nav.pills': 'Pills',
    'nav.fill-justify': 'Fyld og juster',
    'nav.pills-dropdowns': 'Pills med dropdowns',
    'nav.pagination-basic': 'Grundlæggende paginering',
    'nav.pagination-sizing': 'Paginering størrelse',
    'nav.large': 'Stor',
    'nav.small': 'Lille',
    'nav.center': 'Center',
    'nav.pagination-alignment': 'Paginering justering',
    'nav.breadcrumb-basic': 'Grundlæggende brødkrummer',

    /* 07.17.Popover & Tooltip */
    'popover-tooltip.popover': 'Popover',
    'popover-tooltip.tooltip': 'Værktøjstip',

    /* 07.18.Sortable */
    'sortable.columns': 'Sortering af kolonner',
    'sortable.basic': 'Grundlæggende',
    'sortable.handles': 'Håndtag',

    /* 07.19.Maps */
    'maps.google': 'Google',
    'maps.yandex': 'Yandex',

    /* 07.20.Tables */
    'table.bootstrap-tables': 'Bootstrap-tabeller',
    'table.bootstrap-basic': 'Grundlæggende tabel',
    'table.bootstrap-striped': 'Stribede rækker',
    'table.bootstrap-bordered': 'Tabel med ramme',
    'table.bootstrap-borderless': 'Tabel uden ramme',
    'table.bootstrap-hoverable': 'Rækker med hover-effekt',
    'table.bootstrap-responsive': 'Responsiv tabel',
    'table.react-tables': 'React-tabeller',
    'table.react-pagination': 'Paginering',
    'table.react-scrollable': 'Rullebar',
    'table.react-advanced': 'Filter, længde og hop',

    /* Property Info */
    "property-info.allcustomers": 'Alle kunder',
    'property-info.external-sources': 'Eksterne kilder',
    'property-info.faq': 'FAQ',
    'property-info.documents': 'Dokumenter',
    'property-info.publish-ai': 'Udgiv AI',
    'property-info.pre-built-templates': 'Forudbyggede skabeloner',
    'property-info.room-types': 'Værelsestyper',
    'property-info.about-property': 'Om ejendommen',
    'property-info.about-properties': 'Om ejendomme',
    'property-info.facilities-services': 'Faciliteter og services',
    'property-info.property-facilities': 'Ejendomsfaciliteter',
    'property-info.room-amenities': 'Værelsesfaciliteter',
    'property-info.property-contact': 'Ejendomskontakt',
    'property-info.property-activities': 'Ejendomsaktiviteter',
    'property-info.property-location': 'Ejendommens placering',
    'property-info.about-rooms': 'Værelser',
    'property-info.about-sites': 'Om steder',
    'property-info.special-emergencies': 'Nødsituationer',
    'property-info.gallery': 'Galleri',
    'property-info.policies': 'Politikker',
    'property-info.nearby': 'I nærheden',
    'property-info.transport': 'Transport',
    'property-info.location': 'Beliggenhed',
    'property-info.about-rhproperty': 'Om plejehjem',
    'property-info.related-topics': 'Relaterede emner',
    'property-info.assistant-options': 'Velkomstbesked',
    'property-info.restaurant-assistant-information': 'Restaurantinformation',
    'property-info.restaurant-assistant-options': 'Velkomstbesked',
    'property-info.channel-messages': 'Kanalbeskeder',
    'property-info.icon.gallery': 'Ikonbibliotek',
    'property-info.copilot': 'Copilot',
    'property-info.sprint': 'Sprint',
    'property-info.home-information': 'Hjemmeinformation',
    'property-info.loction': 'Steder',
    'property-info.rooms-and-images': 'Værelser og billeder',
    'property-info.trainig-data': 'AI-træningsdata',
    'property-info.publishMonitor': 'Udgiv og overvåg',
    'property-info.webWidget': 'Web Widget',
    'property-info.media': 'Media',
    'property-info.flows': 'Flows',
    'property-info.add-your-own': 'Tilføj din egen',
    'property-info-utility-miscellaneous': 'Diverse',
    'property-info-utility-payment': 'Betalinger',
    'property-info-utility-broadband': 'Bredbånd',
    'property-info-utility-emergency': 'Nødsituation',
    'property-info-utility-mobile': 'Mobil',
    'property-info-utility-moving': 'Flytning',

    /** Rate & Promo */
    'rate-promo.rate-plans': 'Prisplaner',
    'rate-promo.rate-plan-addons': 'Tilføjelser',
    'rate-promo.rate-plan-promos': 'Kampagner',

    'title.property-information': 'Ejendomsinformation',

    'property.message': 'Besked',
    'property.example': 'Eksempel',
    'property.link': 'Links',
    'property.image-carousel': 'Billedkarusel',
    'property.Title': 'Titel',
    'property.SubTitle': 'Undertitel',

    'property.add-invoke-api': 'Kald API',
    'property.add-message-button': 'Tilføj beskeder',
    'property.add-img-button': 'Tilføj billeder',
    'property.add-link-button': 'Tilføj link',

    'property.add-herocard-button': 'Tilføj Hero-kort',
    'property.add-api-button': 'Tilføj knapper',

    'menu.settings': 'Indstillinger',
    'menu.workflows': 'Arbejdsprocesser',
    'menu.product_services': 'Produkter & tjenester',
    'menu.product_recommander': 'Produktanbefaler',
    'menu.digital_guide_book': 'Digital guidebog',
    'menu.welcome_message': 'Velkomstbesked',
    'menu.about-property': 'Om ejendommen',
    'menu.property-facilities': 'Ejendomsfaciliteter',
    'menu.room-amenities': 'Værelsesfaciliteter',
    'menu.property-contact': 'Ejendomskontakt',
    'menu.about-rooms': 'Værelser',
    'menu.special-emergencies': 'Nødsituationer',
    'menu.show-filter': 'Filtre',
    'menu.new': 'Ny',
    'menu.channel': 'Kanaler',
    'menu.application': 'Applikationer',

    'dashboards.send': 'Send',
    'dashboards.hello': 'Hej',
    'dashboards.notificationsAllowed': 'Notifikationer tilladt',
    'dashboards.allowNotifications': 'Tillad notifikationer',
    'dashboards.views': 'Visninger',
    'dashboards.bookingURL': 'Booking-URL',
    'dashboards.searchTags': 'Søg Tags',
    'dashboards.searchCategoryTags': 'Søg kategoritags',
    'dashboards.bedroom': 'Soveværelse',
    'dashboards.addBedroom': 'Tilføj soveværelse',
    'dashboards.frequency': 'Frekvens',
    'dashboards.includeSubpages': 'Inkluder under­ sider',
    'dashboards.enableFaqs': 'Aktivér FAQ',
    'dashboards.faqsDescription': 'Aktivering af FAQs giver dig mulighed for at indtaste spørgsmål, mens systemet udtrækker tilsvarende svar fra websideindholdet for at skabe komplette FAQs',
    'dashboards.faq': 'FAQ',
    'dashboards.deleteDocument': 'Slet dokument',
    'dashboards.confirmDelete': 'Er du sikker på, at du vil slette?',
    'dashboards.addItem': 'Tilføj element',
    'dashboards.addFirstWebPage': 'Tilføj din første webside',

    'dashboards.popular-compendium': 'Populære kompendium-menupunkter',
    'dashboards.wordcloudofcompendium': 'Word Cloud over kompendium-menupunkter',
    'dashboards.wordcloudonthings': 'Word Cloud over ting besøgende spørger om samt menupunkter',
    'dashboards.common-asked': 'Ofte stillede spørgsmål',

    'dashboards.website-visitor-asking': 'Ting opkaldere spørger om',
    'dashboards.visit-country': 'Websitebesøg efter land',
    'dashboards.visit-traffic': 'Land for website-trafik',
    'dashboards.rooms-product': 'Værelser & Produkter',
    'dashboards.popular-room-product': 'Populære værelser og produkter',

    'dashboards.messenger-stats': 'Populære menupunkter',
    'dashboards.messenger-stats-topic-view': 'Statistik over visninger af menupunkter',
    'dashboards.messenger-stats-visits': 'Menupunktvisninger',
    'dashboards.opening-menu-items': 'Antal besøgende der åbner menupunkter',

    'dashboards.number-totalavatarclick': 'Samlede avatar-klik',

    'dashboards.clicks': 'Klik',
    'dashboards.leads': 'Leads',
    'dashboards.hours': 'Timer',
    'dashboards.minutes': 'Minutter',
    'dashboards.connect': 'Forbind',
    'dashboards.ai-chatbot': 'AI Chatbot',
    'dashboards.compendium': 'Kompendium',
    'dashboards.compendium-digital-usage': 'Digitalt Kompendium-brug',
    'dashboards.compendium-unique-visits': 'QR-kode scanninger/klik',
    'dashboards.compendium-opening-menu-items': 'Antal viste menupunkter',
    'dashboards.compendium-total-digital-clicks': 'Samlede menupunktvisninger',
    'dashboards.compendium-total-qr-code': 'Samlede QR-kode scanninger/klik',
    'dashboards.compendium-avg-menu-items': 'Gns. menupunktvisninger pr. scanning',

    'property.delete': 'Slet',
    'menu.userroles': 'Brugere & Roller',
    'menu.members': 'Medlemmer',
    'menu.guest-pass': 'Gæsteadgangsudgange',
    'menu.ratebookings': 'Priser & Bookinger',
    'dashboards.engagement-time': 'Digital assistent engagementstid',
    'dashboards.conversations-minutes': 'Samlede minutter & natlige (19-07) samtaleminutter',
    'dashboards.visitor-questions': 'Besøgsrelaterede spørgsmål',
    'dashboards.recent-queries': 'Seneste forespørgsler',
    'dashboards.visitor-saying': 'Hvad dine opkaldere taler om',
    'dashboards.contacts-prechatform-leavemessage': 'Gemte kontakter fra Pre-Chat formular & Besked efterladt',
    'menu.dashboards': 'Indsigter',
    'menu.ari': 'Tilgængelighed & Priser',
    'menu.conversations': 'Samtaler',
    'menu.conversations.unified-inbox': 'Samlet Indbakke',
    'menu.conversations.active': 'Agentassistance',
    'menu.conversations.archives': 'Arkiver',
    'menu.conversations.missed-responses': 'Manglende svar',
    'menu.conversations.ticket': 'Billetter',
    'menu.conversations.reply-templates': 'Svartemplates',
    'menu.bookings': 'Reservationer & Bookinger',
    'menu.tickets': 'Leads & Billetter',
    'menu.propinfo': 'Knowledge Hub',
    'menu.rate-promos': 'Priser & Kampagner',
    'menu.finance': 'Finans',
    'menu.integration': 'Forbindelser',
    'menu.admin': 'Admin & Sikkerhed',
    'menu.favourites': 'Favoritter',
    'menu.recommender': 'Samtaleflows',
    'menu.assistant-setup': 'Assistentopsætning',
    'menu.admin-insights': 'Admin Indsigter',
    'menu.super-admin': 'Super Admin',
    'menu.groups': 'Grupper',
    'menu.properties': 'Ejendomme',
    'menu.service-provider': 'Serviceudbydere',
    'menu.spaces': 'Arealer',
    'menu.content-manager': 'Indholdshåndtering',
    'menu.events-calendar': 'Begivenhedskalender',
    'menu.appearance-settings': 'Udseende & Indstillinger',
    'menu.help': 'Hjælp',
    'menu.availability': 'Tilgængelighed',
    'menu.myAccounts': 'Mine konti',
    'menu.guest-messaging': 'Gæstebeskeder',

    'guest-messaging.settings': 'Indstillinger',
    'guest-messaging.outreach-setup': 'Outreach Opsætning',
    'guest-messaging.reservations': 'Reservationer',
    'guest-messaging.insights_logs': 'Indsigter og logfiler',
    'guest-messaging.settings.placeholder': 'Konfigurer præferencer for gæstebeskeder.',
    'guest-messaging.outreach.placeholder': 'Opsæt outreach-kampagner og templates.',
    'guest-messaging.reservations.placeholder': 'Administrer reservationsrelaterede beskeder.',
    'guest-messaging.placeholder': 'Modul til gæstebeskeder kommer snart.',
    'guest-messaging.reservation-source': 'Reservationsdatakilde',
    'guest-messaging.communication-channels': 'Kommunikationskanaler',
    'guest-messaging.templates': 'Templates',
    'guest-messaging.link': 'Link',
    'guest-messaging.business-profile': 'Virksomhedsprofil',

    'dashboards.tickets-by-category': 'Billetter efter kategori',
    'dashboards.download': 'Download',
    'dashboards.space-booking': 'Arealbooking',
    'dashboards.gift-voucher': 'Gavekort',
    'dashboards.chatbots': 'Chatbots',
    'dashboards.form': 'Fra',
    'dashboards.to': 'Til',
    'dashboards.active-groups': 'Aktive grupper',
    'dashboards.active-properties': 'Aktive ejendomme',
    'dashboards.live-properties': 'Live ejendomme',
    'dashboards.properties-going': 'Ejendomme der går live i datoperiode',
    'dashboards.start-date': 'Startdato',
    'dashboards.end-date': 'Slutdato',
    'dashboards.all-properties-with': 'Alle ejendomme med live-status',
    'dashboards.aibot-by-country': 'AI Chatbot-kunder efter land',
    'dashboards.list-live-clients': 'Liste over live-kunder der bruger AI Chatbot',
    'dashboards.subscribe-to-reports': 'Abonnér på rapporter',
    'dashboards.website-visits': 'Websitebesøg',
    'dashboards.unique-visitors': 'Unikke besøgende',
    'dashboards.last-week': 'Sidste uge',
    'dashboards.this-week': 'Denne uge',
    'dashboards.this-month': 'Denne måned',
    'dashboards.previous-month': 'Forrige måned',
    'dashboards.yeartodate': 'År til dato',
    'dashboards.lastyear': 'Sidste år',
    'dashboards.last-7-days': 'Seneste 7 dage',
    'dashboards.last-30-days': 'Seneste 30 dage',
    'dashboards.last-60-days': 'Seneste 60 dage',
    'dashboards.last-90-days': 'Seneste 90 dage',
    'dashboards.conversion-rates': 'Konverteringsrater',
    'dashboards.digital-assistant-engagement': 'Digital assistent engagement',
    'dashboards.total-overnight-conversations': 'Samlede & natlige (19-07) samtaler',
    'dashboards.percentage-accuracy': 'Forståelsesnøjagtighed',
    'dashboards.percentage-conversion': 'Website-trafik til chat konvertering',
    'dashboards.percentage-avatarclick': 'Website-trafik til avatar-klik',
    'dashboards.percentage-negativefeedback': 'Negativ feedback som % af avatar-klik',
    'dashboards.percentage-amenties': 'Forespørgsler om faciliteter',
    'dashboards.percentage-booking': 'Bookingforespørgsler',
    'dashboards.percentage-webchats': 'Website-chats',
    'dashboards.percentage-facebookchat': 'Facebook-chats',
    'dashboards.number-webchattime': 'Total samtaletid',
    'dashboards.number-totalconversation': 'Samlede samtaler',
    'dashboards.number-averagetimeconversation': 'Gennemsnitlig tid per samtale',
    'dashboards.number-websiteconversation': 'Website-samtaler',
    'dashboards.number-facebookconversation': 'Facebook-samtaler',
    'dashboards.number-estimatedtimesaving': 'Estimeret tidsbesparelse',
    'dashboards.number-googlemapsconversation': 'Google Maps-samtaler',
    'dashboards.number-whatsappconversation': 'WhatsApp-samtaler',
    'dashboards.number-instagramconversation': 'Instagram-samtaler',
    'dashboards.number-agentconversation': 'Agent-samtaler',
    'dashboards.number-amenityqueries': 'Forespørgsler om faciliteter',
    'dashboards.number-bookingenquiries': 'Bookingforespørgsler',
    'dashboards.number-groupbookingenquiries': 'Gruppebooking forespørgsler',
    'dashboards.number-eventenquiries': 'Event forespørgsler',
    'dashboards.number-longstayenquiries': 'Langtidsophold forespørgsler',
    'dashboards.number-totaltickets': 'Billetter',
    'dashboards.number-returncustomer': 'Tilbagevendende kunder',
    'dashboards.number-redirects': 'Website-omdirigeringer',
    'dashboards.number-bookingengineleads': 'Bookingmotor-leads',
    'dashboards.number-roomnightsreferred': 'Henvist værelsesnætter',
    'dashboards.number-revenuereferred': 'Henvist omsætning',
    'menu.bookingsmenu': 'Bookinger',
    'menu.guests': 'Gæsteinformation',
    'menu.whatsnew': 'Hvad er nyt',


    'menu.formbuilder': 'Form Builder',
    'forms.forms-title': 'Formular',
    "dashboards.trainAI": "Træn AI med dokumenter",
    "dashboards.uploadDocuments": "Upload dokumenter, så din AI kan lære om din virksomhed og hjælpe kunderne, som du ville gøre. Du kan tilføje filer i .doc, .pdf eller .txt.",
    'dashboards.welcomeMessage': 'Velkomstbesked',
    'dashboards.personalizeGreeting': 'Tilpas måden kunderne bliver hilst velkommen på, så den afspejler din virksomheds brand, stil og etikette — og sikrer den varmeste velkomst.',
    'dashboards.addRoomDetails': 'Tilføj detaljer om hvert af dine værelser, så gæster nemt kan finde de nødvendige oplysninger og vælge det perfekte værelse.',
    'dashboards.trainAIFAQs': 'Træn AI med ofte stillede spørgsmål',
    'dashboards.manualQuestions': 'Nogle spørgsmål kan ikke besvares med dokumenter eller findes på hjemmesiden. Her kan du manuelt tilføje spørgsmål, så kunderne altid får de oplysninger, de har brug for.',
    'dashboards.publishAI': 'Udgiv AI for at afspejle de seneste opdateringer',
    'dashboards.retrainAfterChanges': 'Når du foretager ændringer i Knowledge Hub eller formularer, skal du gen-træne chatbotten. Udgivelsen sikrer, at chatbotten giver de mest præcise og opdaterede svar.',
    'dashboards.enhanceKnowledge': 'Forbedr AI-viden ved at spore ubesvarede spørgsmål',
    'dashboards.reviewUnanswered': 'Når AI ikke kan besvare et spørgsmål, vises det her. Gennemgå dem for at identificere mangler i din Knowledge Hub.',
    'dashboards.manageMedia': 'Administrer medier',
    'dashboards.mediaGallery': 'Når du uploader billeder såsom værelser, faciliteter, logoer eller din avatar, vises de i dette galleri.',
    'dashboards.createForms': 'Opret formularer nemt og modtag besked ved hver indsendelse.',
    'dashboards.manageForms': 'Opret og administrer formularer for at indsamle kundeinformation og tilpas dem til forskellige sprog.',
    'dashboards.personalizeResponse': 'Tilpas svarstil og samtaleforløb',
    'dashboards.controlConversation': 'Denne avancerede funktion giver dig kontrol over, hvordan samtaler udvikler sig på tværs af kanaler.',

    'menu.virtualfrontdesk': 'Virtuel Reception',
    'menu.guestservice': 'Gæsteservice',
    'virtual-front.common-questions': 'Almindelige Spørgsmål',
    'virtual-front.add-on-upsells': "Tilvalg & Opgraderinger",
    'virtual-front.service-order': 'Servicebestillinger',
    'virtual-front.guest-service-add-on-upsells': 'Digitalt Kompendium',
    'virtual-front.outbound': 'Udgående',
    'virtual-messenger': 'Web Widget Menus',

    'missed-response.missed-response-title': 'Mistet svar titel',

    // Unified Inbox
    'content.allconversation': 'Alle samtaler',
    'content.active': 'Aktiv',
    'content.tickets': 'Billetter',
    'content.filter': 'Filter',
    'content.createtickets': 'Opret billet',
    'content.conversation': 'Samtale',
    'content.knowledgesearch': 'Viden Søgning',
    'content.reply': 'Svar',
    'content.visitorinfo': 'Besøgsinfo',
    'content.callinfo': 'Opkaldsinfo',
    'content.allinsights': 'Alle Indsigter',
    'content.availabilityrates': 'Tilgængelighed & Priser',
    'content.callback': 'Tilbagekald',
    'content.close': 'Luk',
    'content.sms': 'SMS',
    'content.timestamp': 'Tidsstempel',
    'content.topics': 'Emner',
    'content.callingparty': 'Opkaldende part',
    'content.accountdomain': 'Kontodomæne',
    'content.calledparty': 'Modtager',
    'content.recording': 'Optagelse',
    'content.phonesystemoriginationcallid': 'Telefon System Oprindelses-ID',
    'content.phonesystemterminationcallid': 'Telefon System Afslutnings-ID',
    'content.uniqueconversationid': 'Unik samtale-ID',
    'content.regenerateinsights': 'Gendan indsigter',
    'content.customersentiment': 'Kundesindelag',
    'content.neutral': 'Neutral',
    'content.conversationinsights': 'Samtaleindsigter',
    'content.customeridverification': 'Kunde-ID verifikation',
    'content.serviceactivationdate': 'Serviceaktiveringsdato',
    'content.followups': 'Opfølgninger',
    'content.actionneeded': 'Handling påkrævet',
    'content.uniqueConversationId': 'Unik Samtale-ID',
    'content.uniqueChatId': 'Unik Chat-ID',
    'content.recording&transcript': 'Optagelse & Udskrift',
    'content.chatinsights': 'Chat-indsigter',
    'content.visitedpages': 'Besøgte sider',
    'content.deviceinfo': 'Enhedsinfo',
    'content.chatstartedonthispage': 'Chat startet på denne side',
    'content.prechatinfo': 'Pre-chat Info',
    'content.notes': 'Noter',
    'content.reassign': 'Tildel igen',
    'content.open': 'Åben',
    "content.dismiss": "Luk",
    "content.add_placeholder": "Tilføj pladsholderværdier",
    "content.mobile_number": "Mobilnummer",
    "content.please_select": "Vælg venligst",
    'content.sendwhatsapp': 'Send WhatsApp-besked',

    // Missed response
    'feedback.missed-question': 'Mistet spørgsmål',
    'feedback.conversation-summary': 'Samtaleresumé',
    'feedback.dates-in-spanish': 'Datoer skal være på spansk',
    'feedback.resolve': 'Løs',
    'feedback.ignore': 'Ignorer',

    // Integration
    'integration.select_properties': 'Vælg ejendomme',
    'integration.select_properties_enabled': 'Vælg de ejendomme, der er aktiveret gennem denne integration',
    'integration.services_addons': 'Vælg tjenester & tilvalg',
    'integration.services_visible': 'Vælg hvilke tjenester & tilvalg, der skal være synlige på denne side',
    'integration.appearance': 'Udseende',
    'integration.appearance_customize': 'Vælg din digitale assistents navn, avatar og farver',
    'integration.booking_calendar': 'Bookingkalender',
    'integration.booking_calendar_style': 'Vælg stil for bookingkalenderens pop-up',
    'integration.nudges': 'Nudges',
    'integration.nudges_setup': 'Opsæt proaktive beskeder til besøgende',
    'integration.position': 'Position',
    'integration.position_control': 'Styr placeringen af chatwidgeten på dit website',
    'integration.custom_fonts': 'Brugerdefinerede skrifttyper',
    'integration.custom_fonts_upload': 'Upload skrifttyper du vil bruge',
    'integration.custom_css': 'Brugerdefineret CSS',
    'integration.custom_css_usage': 'Brug CSS til at tilpasse dit Digitale Kompendium',
    'integration.location': 'Placering',
    'integration.location_embed': 'Tilføj din indlejrede lokations-URL',
    'integration.external_links': 'Eksterne links',
    'integration.external_links_add': 'Tilføj dine links',
    'integration.language': 'Sprog',
    'integration.widget_languages': 'Vælg sprog til chatwidget',
    'integration.chatbot_contact': 'Chatbot',
    'integration.chatbot_enable': 'Aktivér din digitale assistent',
    'integration.chatbot_security': 'Hold din Messenger sikker',
    'integration.chatbot_trusted_pages': 'Tilføj betroede sider for at vise chatbotten',
    'integration.chatbot_publish': 'Udgiv din digitale assistent',
    'integration.chatbot_install': 'Kopiér kode for at installere din digitale assistent',

};

export default daMessages;
